import axios from 'axios';

const GET_OPEN_TICKET: string = 'api/reclamation/list/open';
const GET_ARCHIVED_TICKET: string = 'api/reclamation/list/closed';

export const getOpenTickets = async () => {
  const response = await axios.get(GET_OPEN_TICKET);
  return response.data;
};

export const getArchivedTicket = async () => {
  const response = await axios.get(GET_ARCHIVED_TICKET);
  return response.data;
};
